module.exports = __webpack_public_path__ + "img/diamond_bg.f4185cfb.webp";